export default __webpack_public_path__ + "static/media/mansa3.6068e5b4.jpeg";